export const languageOptions = [
    { value: "no", label: "不翻译" },
    // { value: "cn", label: "中文" },
    { value: "en", label: "英文" },
    { value: "ja", label: "日语" }
    // { value: "ko", label: "韩语" },
    // { value: "de", label: "德语" },
    // { value: "fr", label: "法语" },
    // { value: "ru", label: "俄语" },
];
export const languageOptionsInfo = [
    { value: "no", label: "不翻译" },
    { value: "en", label: "英语" },
    { value: "ja", label: "日语" }
];
export const languageOptionsSearch = [
    { value: "", label: "全部语言" },
    { value: 'cn', label: '中文' },
    { value: 'en', label: '英文' },
    { value: 'ja', label: '日语' },
    { value: 'yue', label: '粤语' },
    { value: 'fspk', label: '中英文自由说' },
];
export const sourceLanguageOptions = [
    { value: 'cn', label: '中文' },
    { value: 'en', label: '英文' },
    { value: 'ja', label: '日语' },
    { value: 'yue', label: '粤语' },
    { value: 'fspk', label: '中英文自由说' },
];
export const speakerOptions = [
    { value: 1, label: "暂不区分" },
    { value: 0, label: "不定人数" },
    { value: 2, label: "2人对话" },
];